import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const authRoutes = [
  <Route
    key="auth-linked"
    exact
    path="/auth/linked"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/AuthLinked")}
      />
    )}
  />,
  <Route
    key="login"
    exact
    path="/login"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Login")}
      />
    )}
  />,
  <Route
    key="logintoken"
    exact
    path="/logintoken"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/LoginWithToken")}
      />
    )}
  />,
  <Route
    key="register"
    exact
    path="/register"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Register")}
      />
    )}
  />,
  <Route
    key="register-verification"
    exact
    path="/register/verification"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Register_Otp")}
      />
    )}
  />,
  <Route
    key="register-basic-info"
    exact
    path="/register/basic_info"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Register_BasicInfo")}
      />
    )}
  />,
  <Route
    key="register-choose-program"
    exact
    path="/register/choose_program"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Register_ChooseProgram")}
      />
    )}
  />,
  <Route
    key="register-more-info"
    exact
    path="/register/more_info"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Register_More_Info")}
      />
    )}
  />,
  <Route
    key="register-invoices"
    exact
    path="/register/invoices"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Register_Invoices")}
      />
    )}
  />,
  <Route
    key="password-reset"
    exact
    path="/passwordreset"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/ForgotPassword")}
      />
    )}
  />,
  <Route
    key="delete-account"
    exact
    path="/delete_account"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/DeleteAccount")}
      />
    )}
  />
];

export default authRoutes; 